
import { defineComponent } from 'vue'
import { downloadDirectFromResponse } from '@/helpers/commons/fileHelper'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import descriptor from './OlapOutputWizardDescriptor.json'
import Dropdown from 'primevue/dropdown'
import InlineMessage from 'primevue/inlinemessage'
import RadioButton from 'primevue/radiobutton'
import ProgressSpinner from 'primevue/progressspinner'

export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { Dialog, Dropdown, InlineMessage, RadioButton, ProgressSpinner },
    props: { olapVersionsProp: { type: Boolean, required: true }, sbiExecutionId: { type: String } },
    emits: ['close'],
    computed: {
        saveDisabled(): any {
            if ((this.selectedType === 'file' && this.fieldDelimiter.length > 0) || (this.selectedType === 'table' && this.tableName.length > 0)) {
                return false
            } else return true
        }
    },
    data() {
        return {
            descriptor,
            loading: false,
            selectedVersion: null as any,
            selectedType: 'file' as any,
            tableName: 'WHATIFOUTPUTTABLE',
            fieldDelimiter: '|'
        }
    },
    watch: {},
    created() {},
    methods: {
        saveRequest() {
            if (this.selectedType === 'file') {
                this.loading = true
                this.$http
                    .get(process.env.VUE_APP_OLAP_PATH + `1.0/analysis/csv/${this.selectedVersion.id}/${this.fieldDelimiter}?SBI_EXECUTION_ID=${this.sbiExecutionId}`, {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
                        }
                    })
                    .then((response: AxiosResponse<any>) => {
                        downloadDirectFromResponse(response)
                        this.$store.commit('setInfo', { title: this.$t('common.downloading'), msg: this.$t('managers.mondrianSchemasManagement.toast.downloadFile.downloaded') })
                    })
                    .catch(() => {
                        this.$store.commit('setError', { title: this.$t('common.error.downloading'), msg: this.$t('common.error.downloading') })
                    })
                    .finally(() => (this.loading = false))
            } else {
                this.loading = true
                this.$http
                    .get(process.env.VUE_APP_OLAP_PATH + `1.0/analysis/table/${this.selectedVersion.id}/${this.tableName}?SBI_EXECUTION_ID=${this.sbiExecutionId}`, { headers: { Accept: 'application/json, text/plain, */*' } })
                    .then(async () => {
                        this.$store.commit('setInfo', { title: this.$t('common.information'), msg: this.$t('common.toast.updateSuccess') })
                    })
                    .catch(() => {})
                    .finally(() => (this.loading = false))
            }
        },
        resetFields() {
            this.tableName = 'WHATIFOUTPUTTABLE'
            this.fieldDelimiter = '|'
            this.selectedVersion = null
        }
    }
})
